"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckoutContextProvider = exports.useCheckout = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const react_1 = require("react");
const SHIPPING_SELECT = {
    id: true,
    title: true,
    price: { amount: true, tax: { rate: true } },
    onDeliveryPrice: { amount: true, tax: { rate: true } },
};
const CheckoutContext = (0, react_1.createContext)({
    shippingMethods: undefined,
    appliedCoupons: [],
    setAppliedCoupons: () => ({}),
    tokens: {},
});
function useCheckout() {
    return (0, react_1.useContext)(CheckoutContext);
}
exports.useCheckout = useCheckout;
function CheckoutContextProvider({ tokens, children, }) {
    const { data: shippingMethods } = (0, app_1.useQuery)('getShippings', {
        select: SHIPPING_SELECT,
    });
    const [appliedCoupons, setAppliedCoupons] = (0, react_1.useState)([]);
    const value = (0, react_1.useMemo)(() => ({
        shippingMethods: shippingMethods !== null && shippingMethods !== void 0 ? shippingMethods : undefined,
        appliedCoupons,
        setAppliedCoupons,
        tokens: tokens !== null && tokens !== void 0 ? tokens : {},
    }), [appliedCoupons, shippingMethods, tokens]);
    return ((0, jsx_runtime_1.jsxs)(app_1.Context, Object.assign({ name: "checkout", render: "div" }, { children: [(0, jsx_runtime_1.jsx)(CheckoutContext.Provider, Object.assign({ value: value }, { children: children })), (0, jsx_runtime_1.jsx)(app_1.Global, { styles: (0, app_1.css) `
          ${(theme) => theme.global}
        ` })] })));
}
exports.CheckoutContextProvider = CheckoutContextProvider;
